import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { toCamelCase } from '../../helpers/toCamelCase';
import { defaultSettings } from '../../config/defaultSettings';
import { titles, descriptions } from '../../locales/notifications';
import mergeStates from '../../helpers/mergeStates';
import Select from 'react-select';

import { saveSettings } from '../../store/modules/settings';
import { saveProfileSettings } from '../../store/modules/profilesettings';
import { addFeedback } from '../../store/modules/feedback';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Toggle from 'material-ui/Toggle';
import { Tabs, Tab } from 'material-ui/Tabs';

import classes from './FormSettings.scss';
import { communicationTypes } from '../../models/Activity';

const mapActionCreators: { aveSettings: Function } = {
  saveSettings,
  saveProfileSettings,
  addFeedback,
};

const mapStateToProps = state => ({
  settings: state.settings.settings,
  profileSettings: state.profileSettings.settings,
  user: state.login.user,
});

const taskOrders = [
  {
    value: 'due_date',
    label: 'Nach Fälligkeit (Standard)',
  },
  {
    value: 'created_at',
    label: 'Nach Erstellung',
  },
  {
    value: 'title',
    label: 'Alphabetisch',
  },
];

export class FormSettings extends React.Component {
  constructor(props) {
    super(props);

    let localSettings = {
      taskOrder: taskOrders[0].value,
    };

    const localSettingsSaved = JSON.parse(
      localStorage.getItem('localSettings'),
    );

    if (
      localSettingsSaved !== null &&
      typeof localSettingsSaved !== 'undefined'
    ) {
      localSettings = Object.assign({}, localSettings, localSettingsSaved);
    }

    this.state = {
      slideIndex: 0,
      showConfirmDialog: false,
      settings: props.settings,
      profileSettings: {
        email: props.profileSettings.email,
        new_password: '',
        current_password: '',
      },
      localSettings,
    };
  }

  handleTabChange = value => {
    this.setState({
      slideIndex: value,
    });
  };

  toggleConfirmDialog = forceClose => {
    forceClose = typeof forceClose !== 'undefined';

    if (forceClose === true) {
      this.setState({
        showConfirmDialog: false,
      });
    } else {
      this.setState({
        showConfirmDialog: !this.state.showConfirmDialog,
      });
    }
  };

  close = () => {
    this.props.onClose();
  };

  saveSettings = () => {
    this.props.saveSettings(this.state.settings);
  };

  updateSetting = (key, value) => {
    value = value === true ? '1' : '0';

    const nextSettings = this.state.settings;
    nextSettings[key] = value;
    this.setState({
      settings: nextSettings,
    });

    this.saveSettings();
  };

  updateLocalSettings = () => {
    localStorage.setItem(
      'localSettings',
      JSON.stringify(this.state.localSettings),
    );
  };

  selectTaskOrder = event => {
    this.setState({
      localSettings: Object.assign({}, this.state.localSettings, {
        taskOrder: event.value,
      }),
    });
  };

  handleChange = event => {
    const nextState = mergeStates(event, this.state);
    this.setState(nextState);
  };

  renderConfirm = () => {
    const actions = [
      <FlatButton
        label="Abbrechen"
        primary={false}
        onMouseDown={() => {
          this.toggleConfirmDialog(true);
        }}
      />,
      <RaisedButton
        label="Bestätigen"
        primary
        onMouseDown={() => {
          if (
            typeof this.state.profileSettings.current_password !== undefined &&
            this.state.profileSettings.current_password.length >= 6
          ) {
            this.props.saveProfileSettings(this.state.profileSettings);

            let nextState = this.state.profileSettings;
            nextState = {
              email: nextState.email,
              current_password: '',
              new_password: '',
            };
            this.setState({
              profileSettings: nextState,
            });
            this.toggleConfirmDialog(true);
          }
        }}
      />,
    ];

    return (
      <Dialog
        title="Bestätigen"
        actions={actions}
        modal={false}
        open={this.state.showConfirmDialog}
        autoScrollBodyContent
        key="settings.profileSettings.confirm"
        onRequestClose={() => {
          this.toggleConfirmDialog(true);
        }}
        className="form modal-center"
        contentClassName="form-container form-container--confirm"
        titleClassName="form-header"
        actionsContainerClassName="form-footer"
        bodyClassName="form-body"
      >
        <div className={`row`}>
          <div className={'col-xs-12'}>
            <label
              className="simpl-label"
              htmlFor="profileSettings.current_password"
            >
              Geben Sie Ihr aktuelles Passwort ein, um diese Einstellung zu
              ändern:
            </label>
          </div>
          <div className={`col-xs-12`}>
            <input
              name="profileSettings.current_password"
              type="password"
              onChange={e => this.handleChange(e)}
              value={this.state.profileSettings.current_password}
            />
          </div>
        </div>
      </Dialog>
    );
  };

  renderProfileSettings = () => (
    <div>
      <div className={`row`} key={`setting.profile.email`}>
        <div className={'col-xs-12 col-sm-4'}>
          <label className="simpl-label" htmlFor="profileSettings.email">
            E-Mail-Adresse
          </label>
        </div>
        <div className={`col-xs-12 col-sm-4 ${classes.input}`}>
          <input
            name="profileSettings.email"
            onChange={e => this.handleChange(e)}
            value={this.state.profileSettings.email}
          />
        </div>
        <div className={'col-xs-12 col-sm-4'}>
          <RaisedButton
            primary
            label="Email Speichern"
            onMouseDown={() => {
              this.toggleConfirmDialog();
            }}
          />
        </div>
      </div>
      <hr />
      <div className={`row`} key={`setting.profile.password`}>
        <div className={'col-xs-12 col-sm-4'}>
          <label className="simpl-label" htmlFor="profileSettings.new_password">
            Neues Passwort
          </label>
        </div>
        <div className={`col-xs-12 col-sm-4 ${classes.input}`}>
          <input
            name="profileSettings.new_password"
            type="password"
            onChange={e => this.handleChange(e)}
            value={this.state.profileSettings.new_password}
          />
        </div>
        <div className={'col-xs-12 col-sm-4'}>
          <RaisedButton
            primary
            label="Passwort Speichern"
            disabled={
              typeof this.state.profileSettings.new_password === 'undefined' ||
              this.state.profileSettings.new_password.length < 6
            }
            onMouseDown={() => {
              this.toggleConfirmDialog();
            }}
          />
        </div>
      </div>
      {this.state.confirmDialog}
      <hr />
      <div className={`row`}>
        <div className="col-xs-12">
          <h2>Weitere Einstellungen</h2>
        </div>
        <div className={'col-xs-12 col-sm-4'}>
          <label className="simpl-label" htmlFor="profileSettings.taskOrder">
            Sortierung von Aufgaben
          </label>
        </div>
        <div className={`col-xs-12 col-sm-8 ${classes.input}`}>
          <Select
            name="communication_type"
            value={this.state.localSettings.taskOrder}
            options={taskOrders}
            onChange={this.selectTaskOrder}
            placeholder="Sortierung"
            clearable={false}
          />
        </div>
        {/*<div className={'col-xs-12 col-sm-12'}>*/}
        {/*<br />*/}
        {/*<RaisedButton*/}
        {/*primary*/}
        {/*label="Weitere Einstellungen Speichern"*/}
        {/*disabled={*/}
        {/*typeof this.state.profileSettings.new_password === 'undefined' ||*/}
        {/*this.state.profileSettings.new_password.length < 6*/}
        {/*}*/}
        {/*onMouseDown={() => {*/}
        {/*this.toggleConfirmDialog();*/}
        {/*}}*/}
        {/*/>*/}
        {/*</div>*/}
      </div>
    </div>
  );

  renderSettings = () => {
    const settings = [];

    _.forEach(defaultSettings, (value, key) => {
      const title = titles[toCamelCase(key.replace('notification.', ''))];
      const description =
        descriptions[toCamelCase(key.replace('notification.', ''))];

      if (typeof this.state.settings[key] !== 'undefined') {
        value = this.state.settings[key] === '1';
      } else {
        value = value === '1';
      }

      settings.push(
        <div className={`row ${classes.row}`} key={`setting.${key}`}>
          <div className={'col-xs-12 col-sm-10'}>
            <label className={classes.label}>{title}</label>
            <small>{description}</small>
          </div>
          <div className={`col-xs-12 col-sm-2 ${classes.input}`}>
            <Toggle
              toggled={value}
              onToggle={(event, isInputChecked) =>
                this.updateSetting(key, isInputChecked)
              }
            />
          </div>
        </div>,
      );
    });

    return settings;
  };

  render() {
    this.updateLocalSettings();

    const actions = [
      <FlatButton
        primary={false}
        label="Schließen"
        onMouseDown={() => {
          this.close();
        }}
      />,
    ];

    return (
      <Dialog
        title="Einstellungen"
        actions={actions}
        modal={false}
        open
        autoScrollBodyContent
        onRequestClose={() => this.close()}
        className="form modal-center"
        contentClassName="form-container form-container--settings"
        titleClassName="form-header"
        actionsContainerClassName="form-footer"
        bodyClassName="form-body form-body-tabbed"
      >
        <Tabs
          onChange={this.handleTabChange}
          value={this.state.slideIndex}
          inkBarStyle={{ backgroundColor: '#4a90e2' }}
          tabItemContainerStyle={{
            backgroundColor: '#ffffff',
            height: 60,
            minHeight: 60,
            borderBottomWidth: 1,
            borderBottomColor: '#ccc',
            borderBottomStyle: 'solid',
          }}
        >
          <Tab
            label="Profil"
            value={0}
            style={{ color: '#4a90e2', fontWeight: 700, flex: 1 }}
          >
            <div className="PadMe">{this.renderProfileSettings()}</div>
          </Tab>
          <Tab
            label="Benachrichtigungen"
            value={1}
            style={{ color: '#4a90e2', fontWeight: 700, flex: 1 }}
          >
            <div className="PadMe">
              <div className="row">
                <div className="col-xs-12">
                  <p>
                    SiMPL kann Ihnen Benachrichtungen schicken wenn wichtige
                    Ereignisse auftreten, die Sie betreffen.
                  </p>
                </div>
              </div>
              {this.renderSettings()}
            </div>
          </Tab>
          <Tab
            label="Export"
            value={2}
            style={{ color: '#4a90e2', fontWeight: 700, flex: 1 }}
          >
            <div className="PadMe">
              <div className="row">
                <div className="col-xs-12">
                  <p>
                    Sie können Ihre Aktivitäten als{' '}
                    <a
                      href={`webcal://api.simplapp.io/api/integration/activity/${this.props.user.current_simpl_account}/${this.props.user.id}`}
                    >
                      iCal abonnieren
                    </a>
                  </p>
                </div>
                <div className="col-xs-12">
                  <input
                    type="text"
                    readOnly="readonly"
                    value={`https://api.simplapp.io/api/integration/activity/${this.props.user.current_simpl_account}/${this.props.user.id}/${this.props.user.apiIntegrationToken}`}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <p>
                    Sie können weiters Ihre Daten als PDF bei uns{' '}
                    <a href="mailto:info@simplapp.io" target="_blank">
                      anfordern
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </Tab>
        </Tabs>
        {this.renderConfirm()}
      </Dialog>
    );
  }
}

FormSettings.propTypes = {
  settings: PropTypes.object,
  profileSettings: PropTypes.object,
  user: PropTypes.object,
  saveSettings: PropTypes.func,
  saveProfileSettings: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

FormSettings.defaultProps = {
  settings: {},
  profileSettings: {},
};

export default connect(mapStateToProps, mapActionCreators)(FormSettings);



// WEBPACK FOOTER //
// ./src/components/FormSettings/FormSettings.js